/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconTemperature = createReactComponent("outline", "temperature", "IconTemperature", [["path", { "d": "M10 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5", "key": "svg-0" }], ["path", { "d": "M10 9l4 0", "key": "svg-1" }]]);

export { IconTemperature as default };
//# sourceMappingURL=IconTemperature.mjs.map
